import {Spin, Tooltip, Pagination, Popconfirm, Table, ConfigProvider, Modal, Popover, message, Col, Input, Layout, Row, Upload, Button, InputNumber, Select, Radio, RadioChangeEvent} from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import { Content } from 'antd/lib/layout/layout'
import { RouteComponentProps } from 'react-router'
import * as constants from '../../../constants/constants'
import { sendHttpPostRequest } from '../../../api/http-request'
import MarkDownEditor from '@/pages/components/MarkdownEditor/MarkdownEditor'
import Draggable from 'react-draggable'
import zhCN from 'antd/lib/locale/zh_CN'
import oamProjectStyles from './oam-project.module.less'
import GlobalCss from '@/global.module.less'
import idataCodingTableStyles from '../../common/global-styles/idatacoding.module.less'
import { EditOutlined, SearchOutlined, CloseCircleOutlined, RightOutlined,ExclamationCircleOutlined} from '@ant-design/icons'
import {DragDropContext, Droppable, Draggable as DndDraggable} from 'react-beautiful-dnd'
import React, { useEffect, useRef, useState } from 'react'
import PublicTipModal from '@/pages/components/PublicTipModal/PublicTipModal'

import { Checkbox } from 'antd';
import type { CheckboxValueType } from 'antd/es/checkbox/Group';


interface Props extends RouteComponentProps<{ project_id: string }> {
  project_id: string
}

import myStyles from './oam-project.module.less'
import { PlusOutlined } from '@ant-design/icons'

import OAMSider from '../oam-sider'
import Cookies from 'js-cookie'

/** 项目编辑页 */
const typeMap = new Map([
  [1, '实操题'],
  [2, '单选题'],
  [3, '多选题'],
  [4, '排序题'],
  [5, '主观题'],
  [6, '纯讲义'],
])
const difficultyMap = new Map([
  [1, '容易'],
  [2, '中等'],
  [3, '困难'],
])

export const OAMProjectEdit: React.FC<Props> = (props) => {
  const project_id = props.location.search.split('=')[1]
  const [coverFileList, setCoverfileList] = useState([])
  const [name, setName] = useState('') //项目名称
  const [cover, setCover] = useState('') //项目封面图
  const [projectAim, setProjectAim] = useState('') //实训目标
  const [trainingSkills, setTrainingSkills] = useState('') //锻炼能力
  const [tools, setTools] = useState('') //实践工具
  const [teachingHours, setTeachingHours] = useState(0) //实训教学课时
  const [industry, setIndustry] = useState('') //行业
  const [learningHours, setLearningHours] = useState(0) //个人实训课时
  const [annualPriceYuan, setAnnualPriceYuan] = useState(99.8) //项目年付价格(元)
  const [precondition, setPrecondition] = useState('') //前置基础
  const [exercistList, setExerciseList] = useState([] as any) //知识检测习题列表
  const [introduction, setIntroduction] = useState('') //项目介绍
  const [projectSteps, setProjectSteps] = useState([]) //项目流程

  const [projectMenu, setProjectMenu] = useState(null as any) //项目大纲ID
  const [projectMenuName, setProjectMenuName] = useState(null as any) //项目大纲名称
  const [projectReportId, setProjectReportId] = useState(null as any) //项目报告模板ID
  const [projectReportName, setProjectReportName] = useState(null as any) //项目报告模板名称

  const [allCategory, setAllCategory] = useState([] as any) // 所有的分类

  const [projectEnvName, setProjectEnvName] = useState({} as any) //项目信息
  const [project, setProject] = useState({} as any) //项目信息


  const [allImages, setAllImages] = useState([]) //所有镜像选择列表

  // 以下为参考报告生成相关变量
  const [fullReportRunning, setFullReportRunning] = useState(null as any) //是否正在生成参考报告
  const [existFullReport, setExistFullReport] = useState(false) //是否已经存在历史参考报告
  const checkStatusTimer = useRef<any>()
  const [errorDataList, setErrorDataList] = useState(null as any) //报告节点运行信息
  const [stopFullReportTaskModalVis, setStopFullReportTaskModalVis] =  useState(false) //停止生成报告弹窗的显示

  useEffect(() => {
    queryProject()
    queryExerciseList()
    queryAllImages()
    queryAllCategoryList()

    //queryFullReportStatus()
    /*checkStatusTimer.current = setInterval(() => {
      queryFullReportStatus()
    }, 1000)*/

  }, [])


  const onDescMarkdownChange = (value: any) => {
    setIntroduction(value.text)
  }



        /**
     * 查询项目分类列表
     */
    const queryAllCategoryList = () => {
      sendHttpPostRequest(
        'course/api/oam_query_project_category',
  
        {
          sessionid: Cookies.get('sessionid'),
          sid: Cookies.get('sessionid'),

          page:1,
          pagesize:99999
  
        },
        (response: any) => {
          message.destroy()
          if (response.code == -100) {
            // 未登录
            //window.location.href = '/login?next=project'
          } else if (response.is_ok == true) {
            // 成功
            setAllCategory(response?.data?.list)
          }
        }
      )
      
    }


  /**查询系统所有镜像列表 */
  const queryAllImages = () => {
    message.destroy()
    const requestParams = {
      sessionid: Cookies.get('sessionid'),
      page:1,
      pagesize:10000,
    }
    sendHttpPostRequest(
      'course/api/oam_query_project_environment',
      requestParams,
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          window.location.href = '/oam_login?next=oam_project_list'
        } else if (response.code == 0) {
          // 成功
          setAllImages(response.data.list)
        } else if (response.code == -501) {
          // 权限不足
          //window.location.href = '/oam_login?next=oam_image_list'
        } else {
          message.error(response.message)
        }
      }
    )
  }

  // 上传项目介绍图片的参数
  const uploadOption = {
      name: 'image',
      actionUrl: 'course/api/oam_upload_project_image',
      uploadData: { sessionid: Cookies.get('sessionid'),
          project_id:project_id
          },
    }

  const [exerciseListResult, setExerciseListResult] = useState([] as any[]) // 当前显示的任务搜索
  const [exerciseResultSum, setExerciseResultSum] = useState(0) // 搜索返回的任务结果数
  const [totalExerciseCount, setTotalExerciseCount] = useState(0) // 搜索返回的总任务结果数
  const queryExerciseContent = useRef('') // 记录任务搜索串
  const queryExerciseSource = useRef('2') // 来源 1-个人  2-OAM创建（系统）
  const exerciseOrder = useRef('') // 排序升序降序
  const exerciseOrderBy = useRef('') // 排序列
  const exercisePage = useRef(1) // 记录当前的页数
  const exercisePageSize = useRef(10) // 记录当前每页展示数量

  const typeFilters = useRef([]) // 类型过滤选项
  const difficultyFilters = useRef([]) // 难易程度过滤选项



  /**
   * 生成参考报告
   */
    const generateFullReport = () => {

      sendHttpPostRequest(
        'exercise/api/oam_run_project_exercises',
        {
          sessionid: Cookies.get('sessionid'),
          sid: Cookies.get('sessionid'),
          project_id:  project_id
        },
        generateFullReportCallback
      )
    }

  /**
   * 查询完整报告状态回调
   * @param response
   */
      const generateFullReportCallback = (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          window.location.href = '/oam_login?next=oam_exercise_list'
        } else if (response.code == 0) {
          // 成功
          // 查询后更新页面变量
          setFullReportRunning(true)

          checkStatusTimer.current = setInterval(() => {
            queryFullReportStatus()
          }, 1000)

        } else if (response.code == -501) {
          // 权限不足
          window.location.href = '/oam_login?next=oam_exercise_list'
        } else {
          message.error(response.message)
        }
      }

   /**
   * 查询完整报告生成状态
   *data.status 0 无历史参考报告，1 有且上次运行全部成功， 2 有但上次运行部分失败， 3 有且当前进行中
   */
   const queryFullReportStatus = () => {
    sendHttpPostRequest(
      'exercise/api/oam_get_project_exercises_result',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        project_id:  project_id
      },
      queryFullReportStatusCallback
    )
  }


  /**
   * 查询完整报告状态回调
   * @param response
   */
    const queryFullReportStatusCallback = (response: any) => {
      message.destroy()
      if (response.code == -100) {
        // 未登录
        window.location.href = '/oam_login?next=oam_exercise_list'
      } else if (response.code == 0) {
        // 成功
        // 查询后更新页面变量
        if (response?.data?.status == 0) //是否存在历史报告
        {
          setExistFullReport(false)
          setFullReportRunning(false)
          setErrorDataList(null as any)
          clearInterval(checkStatusTimer.current)

        }else if (response?.data?.status == 3){// 还在运行
          setExistFullReport(true)
          setFullReportRunning(true)
          setErrorDataList(null as any)
        } else if (response?.data?.status == 2){ //运行结束，有错
          setFullReportRunning(false)
          setExistFullReport(true)
          setErrorDataList(response?.data?.list)
          clearInterval(checkStatusTimer.current)
          message.error("参考报告生成失败")
        }else if (response?.data?.status == 1){ // 运行结束，成功
          setExistFullReport(true)
          setFullReportRunning(false)
          setErrorDataList(null as any)
          clearInterval(checkStatusTimer.current)
          message.success("参考报告生成成功")
        }
  
      } else if (response.code == -501) {
        // 权限不足
        window.location.href = '/oam_login?next=oam_exercise_list'
      } else {
        message.error(response.message)
      }
    }


  /**
   * 停止参考报告生成
   */
   const stopFullReportTask = () => {
    sendHttpPostRequest(
      'exercise/api/oam_interrupt_project_exercise',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        project_id:  project_id
      },
      stopFullReportTaskCallback
    )
  }


  /**
   * 停止参考报告生成状态回调
   * @param response
   */
    const stopFullReportTaskCallback = (response: any) => {
      message.destroy()
      if (response.code == -100) {
        // 未登录
        window.location.href = '/oam_login?next=oam_exercise_list'
      } else if (response.code == 0) {
        // 成功
        // 查询后更新页面变量
        setFullReportRunning(false)//停止成功代表任务已经不在运行了
        clearInterval(checkStatusTimer.current)
        message.success('生成报告停止成功')
      } else if (response.code == -501) {
        // 权限不足
        window.location.href = '/oam_login?next=oam_exercise_list'
      } else {
        message.error(response.message)
      }
    }

  /**
   * 查询习题列表
   */
  const queryExerciseList = () => {
    sendHttpPostRequest(
      'exercise/api/oam_query_exercise_list/',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        // type: JSON.stringify([2, 3]),
        query_type: 2,
        query: queryExerciseContent.current,
        page: exercisePage.current,
        pagesize: exercisePageSize.current,
        order: exerciseOrder.current,
        order_by: exerciseOrderBy.current,
        type: JSON.stringify(typeFilters.current),
        difficulty: JSON.stringify(difficultyFilters.current),
        //create_time: createTime.current,
        source: queryExerciseSource.current,
      },
      queryExerciseListCallback
    )
  }

  /**
   * 查询习题列表回调
   * @param response
   */
  const queryExerciseListCallback = (response: any) => {
    // console.log(response)
    message.destroy()
    if (response.code == -100) {
      // 未登录
      window.location.href = '/oam_login?next=oam_exercise_list'
    } else if (response.code == 0) {
      // 成功
      setExerciseListResult(response.exercise_list)
      setExerciseResultSum(response.total_sum)
      setTotalExerciseCount(response.total_count)
    } else if (response.code == -501) {
      // 权限不足
      window.location.href = '/oam_login?next=oam_exercise_list'
    } else {
      message.error(response.message)
    }
  }


  // 添加任务弹窗的一些变量
  const [isAddExerciseModalVisible, setIsAddExerciseModalVisible] = useState(false)
  const currentSelectedExerciseId = useRef(null as any) //记录输入的习题ID
  const draggleRef = useRef<HTMLDivElement | null>(null)

  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
  const [disabled, setDisabled] = useState(true)

  const onStart = (event: any, uiData: any) => {
    const { clientWidth, clientHeight } = window?.document?.documentElement
    const targetRect = draggleRef?.current?.getBoundingClientRect()
    if (targetRect) {
      setBounds({
        left: -targetRect?.left + uiData?.x,
        right: clientWidth - (targetRect?.right - uiData?.x),
        top: -targetRect?.top + uiData?.y,
        bottom: clientHeight - (targetRect?.bottom - uiData?.y),
      })
    }
  }

  // 错误信息弹窗变量
  const [isErrorMeaasgeModalVisible, setIsErrorMeaasgeModalVisible] = useState(false)
  const draggleErrorMessageRef = useRef<HTMLDivElement | null>(null)

  const [errorBounds, setErrorBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
  const [errorDisabled, setErrorDisabled] = useState(true)

  const onErrorStart = (event: any, uiData: any) => {
    const { clientWidth, clientHeight } = window?.document?.documentElement
    const targetRect = draggleErrorMessageRef?.current?.getBoundingClientRect()
    if (targetRect) {
      setErrorBounds({
        left: -targetRect?.left + uiData?.x,
        right: clientWidth - (targetRect?.right - uiData?.x),
        top: -targetRect?.top + uiData?.y,
        bottom: clientHeight - (targetRect?.bottom - uiData?.y),
      })
    }
  }

  /** 选择了某一习题 */
  const rowTaskSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      currentSelectedExerciseId.current = selectedRowKeys[0]
      console.log(
        `selectedRowKeys: ${selectedRowKeys}`,
        'selectedRows: ',
        selectedRows
      )
    },
    getCheckboxProps: (record: any) => ({
      disabled: exercistList.filter((item) => item == record.id).length > 0,
      //name: record.name,
    }),
  }

  //点击了搜索按钮
  const onSearchTaskBtn = (e: any) => {
    exercisePage.current = 1
    queryExerciseContent.current = e.target.value
    queryExerciseList()
  }

  const handleAddExerciseOk = () => {
    //添加任务
    setIsAddExerciseModalVisible(false)
    if (currentSelectedExerciseId.current) {
      console.log(exercistList)
      exercistList.push(currentSelectedExerciseId.current)
      console.log(exercistList)
      setExerciseList(JSON.parse(JSON.stringify(exercistList)))
    }
  }

  const showAddExerciseModal = () => {
    setIsAddExerciseModalVisible(true)
  }

  const handleAddExerciseCancel = () => {
    setIsAddExerciseModalVisible(false)
  }

  // 表格发生变化
  const onExerciseTableChange: any = (
    pagination: any,
    filters: any,
    sorter: any,
    extra: { currentDataSource: []; action: any }
  ) => {
    if (sorter.order) {
      //如果选择了排序列
      exerciseOrder.current = sorter.order
      exerciseOrderBy.current = sorter.field
    }
    if (filters.type) {
      //如果选择了过滤列
      typeFilters.current = filters.type
    } else {
      typeFilters.current = []
    }
    if (filters.difficulty) {
      difficultyFilters.current = filters.difficulty
    } else {
      difficultyFilters.current = []
    }
    exercisePage.current = 1
    queryExerciseList()
  }

  // 渲染类型
  const renderType = (text: any, record: any) => (
    <div>{typeMap.get(parseInt(text))}</div>
  )

  // 渲染难易程度
  const renderDifficulty = (text: any, record: any) => (
    <div>{difficultyMap.get(parseInt(text))}</div>
  )

  const error_columns: any = [
    {
      title: '节点ID',
      dataIndex: 'node_id',
      key: 'node_id',
      align: 'center',
      width: 80,
    },
    {
      title: '节点名称',
      dataIndex: 'node_name',
      key: 'node_name',
      ellipsis: true,
      align: 'left',
      width: 150,
      render: (text, record) => {
        return (
          <span
            className={GlobalCss.link}
            onClick={() => window.open(`/oam_report_node_edit?node_id=${record.node_id}`)}
          >
            {record.node_name}
          </span>
        )
      },
    },
    {
      title: '参考答案',
      dataIndex: 'answer_input_err',
      key: 'answer_input_err',
      ellipsis: true,
      align: 'left',
      width: 120,
      render: (text, record) => {
        return (
          <span>
            {record.answer_input_err==''?'-':record.answer_input_err}
          </span>
        )
      },
    },
    {
      title: '任务名称',
      dataIndex: 'exercise_name',
      key: 'exercise_name',
      align: 'left',
      width: 150,
      ellipsis: true,
      render: (text, record) => {
        return ( record.exercise_name == ''? <span>-</span> :
          <span
            className={GlobalCss.link}
            onClick={() => window.open(`/oam_preview_task?task_id=${record.exercise_id}`)}
          >
            {record.exercise_name}
          </span>
        )
      },
    },
    {
      title: '任务运行',
      dataIndex: 'exercise_run_err',
      key: 'exercise_run_err',
      align: 'left',
      width: 120,
      ellipsis: true,
      render: (text, record) => {
        return (
          <span>
            {record.exercise_run_err==''?'-':record.exercise_run_err}
          </span>
        )
      },
      
    },

    
  ]

  const exercise_columns: any = [
    {
      title: '序号',
      dataIndex: 'id',
      key: 'id',
      align: 'center',
      width: 50,
    },
    {
      title: '题目名称',
      dataIndex: 'title',
      key: 'title',
      ellipsis: true,
      align: 'left',
      width: 100,
    },
    {
      title: '备注',
      dataIndex: 'remarks',
      key: 'remarks',
      align: 'center',
      width: 100,
      ellipsis: true,
    },
    {
      title: '题目类型',
      dataIndex: 'type',
      key: 'type',
      align: 'center',
      width: 80,
      render: renderType,
      filters: [
        {
          text: '单选题',
          value: 2,
        },
        {
          text: '多选题',
          value: 3,
        },
      ],
      onFilter: (value: any, record: any) => true,
    },

    {
      title: '难易程度',
      dataIndex: 'difficulty',
      key: 'difficulty',
      align: 'center',
      width: 80,
      render: renderDifficulty,
      filters: [
        {
          text: '容易',
          value: 1,
        },
        {
          text: '中等',
          value: 2,
        },
        {
          text: '困难',
          value: 3,
        },
      ],
      onFilter: (value: any, record: any) => true,
    },
  ]

  //页码和页数发生了变化
  const onExercisePageChange = (
    newPage: number,
    newPageSize?: number | undefined
  ) => {
    exercisePage.current = newPage ? newPage : 1
    if (newPageSize) {
      exercisePageSize.current = newPageSize
    }
    queryExerciseList()
  }

  // 上传案例封面
  const onCoverChange = (info: any) => {
    setCoverfileList(info.fileList)
    const { status } = info.file
    if (status !== 'uploading') {
      //上传中
      console.log(info.file, info.fileList)
    }
    if (status === 'done') {
      //上传成功
      let new_cover = info.file.response.img_url
      let code = info.file.response.code
      setCover(info.file.response.data.file_path)
    } else if (status === 'error') {
      //上传失败
      message.error(`${info.file.name} file upload failed.`)
    }
  }

  // 校验图片类型和大小
  function beforeCoverUpload(file) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    if (!isJpgOrPng) {
      message.error('请上传png或jpg格式的图片!')
    }
    const isLt5M = file.size / 1024 / 1024 < 5
    if (!isLt5M) {
      message.error('请上传小于5M的图片')
    }
    return isJpgOrPng && isLt5M
  }

  // 上传cover传参
  const uploadCoverData = {
    sessionid: Cookies.get('sessionid'),
    sid: Cookies.get('sessionid'),
    project_id: project_id,
  }

  const uploadCoverButton = (
    <div>
      {<PlusOutlined />}
      <div style={{ marginTop: 8 }}>上传封面</div>
    </div>
  )

  /**
   * 更新项目
   */
  const updateProject = () => {
    sendHttpPostRequest(
      'course/api/oam_update_project',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        project_id: project_id,
        name: name,
        project_aim: projectAim,
        tools: tools,
        teaching_hours: teachingHours,
        learning_hours: learningHours,
        precondition: precondition,
        exercist_list: JSON.stringify(exercistList),
        introduction: introduction,
        project_steps: JSON.stringify(projectSteps),
        project_menu: projectMenu,
        project_report_id: projectReportId,
        cover: cover,
        ability: trainingSkills,
        industry: industry,
        env_id: project?.env_id,
        difficulty: project?.difficulty,
        category:  JSON.stringify(project?.category_ids), 
        annual_price_cent: Math.max(Math.round((annualPriceYuan || 0) * 100), 0),
      },
      updateProjectCallback
    )
  }

  /**
   * 更新项目回调
   * @param response
   */
  const updateProjectCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      window.location.href = '/oam_login?next=oam_chapter'
    } else if (response.is_ok == true) {
      // 成功
      //setChapterId(response.chapter_id);
      message.success('项目' + response.project_id + '保存成功~')
    } /*else if (response.code == -501) {
          // 权限不足
          window.location.href = '/oam_login?next=oam_chapter';
      } */ else {
      message.error(response.message)
    }
  }

  /**
   * 查询项目
   */
  const queryProject = () => {
    sendHttpPostRequest(
      'course/api/oam_query_project_by_id',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        project_id: project_id,
      },
      queryProjectCallback
    )
  }

  /**
   * 查询项目回调
   * @param response
   */
  const queryProjectCallback = (response: any) => {
    // console.log(response)
    message.destroy()
    if (response.code == -100) {
      // 未登录
      window.location.href = '/oam_login?next=oam_project'
    } else if (response.is_ok == true) {
      // 成功
      setProject(response?.query_info)
      setProjectEnvName(response?.query_info?.env_name)
      console.log(typeof response.query_info?.test_exercise_list)
      setName(response.query_info?.name)
      setProjectAim(response.query_info?.aim)
      setTools(response.query_info?.tools)
      setTeachingHours(response.query_info?.teaching_duration)
      setLearningHours(response.query_info?.practice_duration)
      setPrecondition(response.query_info?.preconditions)
      setExerciseList(
        typeof response.query_info?.test_exercise_list == 'object'
          ? response.query_info?.test_exercise_list
          : JSON.parse(response.query_info?.test_exercise_list)
      )
      setIntroduction(response.query_info?.description)
      response.query_info?.flow &&
        setProjectSteps(JSON.parse(response.query_info?.flow))
      setProjectMenu(response.query_info?.syllabus_id)
      setProjectMenuName(response.query_info?.syllabus_name)
      setCover(response.query_info?.cover)
      setTrainingSkills(response.query_info?.ability)
      setProjectReportId(response.query_info?.report_id)
      setProjectReportName(response.query_info?.report_name)
      setIndustry(response.query_info?.industry_name)
      setAnnualPriceYuan((response.query_info?.annual_price_cent || 9980) / 100.0)

      if(response.query_info?.answer_report_status == 3){ //代表参考报告正在生成，此时需要开启轮询
        setFullReportRunning(true)
        checkStatusTimer.current = setInterval(() => {
          queryFullReportStatus()
        }, 1000)
      } else if (response.query_info?.answer_report_status == 0){ //没有运行过
        setExistFullReport(false)
      }else if (response.query_info?.answer_report_status == 1){ //代表运行成功
        setExistFullReport(true)
      }else if (response.query_info?.answer_report_status == 2){ // 代表有错误
        setErrorDataList(response.query_info?.answer_report_err_info)
      }
      //setDescription(response.query_info?.description)
      //message.success(response.chapter_id)
    } /*else if (response.code == -501) {
          // 权限不足
          window.location.href = '/oam_login?next=oam_chapter';
      } */ else {
      message.error(response.message)
    }
  }

  // a little function to help us with reordering the result
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list)
    const [removed] = result.splice(startIndex, 1)
    result.splice(endIndex, 0, removed)

    return result
  }

  const grid = 8

  const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    padding: 0,
    //width: 38,
    height: 38,
    margin: `0 ${grid}px 0 0`,
    borderRadius: 2,
    // change background colour if dragging
    background: isDragging ? 'lightgreen' : '#4f46e5',
    color: '#fff',
    // styles we need to apply on draggables
    ...draggableStyle,
  })

  const getListStyle = (isDraggingOver) => ({
    background: isDraggingOver ? 'lightblue' : 'lightgrey',
    display: 'flex',
    padding: grid,
    overflow: 'auto',
  })

  // 项目镜像改变
  const onProjectImageChange = (e: RadioChangeEvent) => {
    project.env_id = e.target.value
    setProject({ ...project })
  }

  // 项目分类改变
  /* const onProjectCategoryChange = (e: RadioChangeEvent) => {
    project.category_ids = [e.target.value]
    setProject({ ...project })
  } */

  const onProjectCategoryChange = (checkedValues: CheckboxValueType[]) => {
    project.category_ids = checkedValues
    setProject({ ...project })
  };



  // 项目难度等级改变
  const onProjectDifficultyChange = (e: RadioChangeEvent) => {
    project.difficulty = e.target.value
    setProject({ ...project })
  }


  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return
    }

    const items = reorder(
      exercistList,
      result.source.index,
      result.destination.index
    )

    setExerciseList(items)
  }
  const addStepBtnClick = () => {
    setProjectSteps([...projectSteps, { step: '', subSteps: [] }])
  }

  interface Props2 {}
  const ProjectSteps: React.FC<Props2> = (props) => {
    return (
      <Row
        gutter={[10, 20]}
        justify="start"
        align="middle"
        wrap={false}
        style={{ padding: 10, width: '800px', overflowX: 'auto' }}
      >
        {projectSteps?.map((item: any, itemInd: number) => {
          return (
            <Col key={itemInd}>
              <Row align="middle" gutter={[10, 20]} wrap={false}>
                <Col>
                  <div className={oamProjectStyles.stepContain}>
                    <div
                      className={
                        oamProjectStyles.stepHeader +
                        ' ' +
                        GlobalCss.towLinesTextOverflow
                      }
                    >
                      {item?.step}
                    </div>
                    <div className={oamProjectStyles.stepWarpper}>
                      {item.subSteps?.map((substep: any, subInd: number) => {
                        return <div key={subInd}> {substep}</div>
                      })}
                    </div>
                  </div>
                </Col>
                {itemInd < projectSteps.length - 1 && (
                  <Col
                    className={
                      oamProjectStyles.arrowBox + ' ' + GlobalCss.ColFlex
                    }
                  >
                    <RightOutlined 
                      style={{ color: '#fff', fontSize: 16,fontWeight:700}}
                    />
                  </Col>
                )}
              </Row>
            </Col>
          )
        })}
      </Row>
    )
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <OAMSider keys={'2'} openKeys={['sub-project']}></OAMSider>
      <div>
        <Content
          style={{
            backgroundColor: '#fff',
            borderRadius: 5,
            minWidth: 800,
            width: 'calc(100vw - 300px)',
            margin: 30,
            paddingTop: 20,
          }}
        >
          <div style={{ paddingLeft: 50, paddingRight: 50, paddingBottom: 50 }} className={oamProjectStyles.editContentWrapper}>
            <Row
              gutter={[8, 8]}
              justify="end"
              align="middle"
              style={{ marginBottom: 20 }}
            >
              <Col span={24} style={{ color: '#00000073', textAlign: 'right' }}>
                <Button
                  onClick={() => {}}
                  style={{ borderRadius: 20, width: 80, marginRight: 10 }}
                  type="primary"
                >
                  {' '}
                  预 览{' '}
                </Button>

                <Button
                  onClick={() => {
                    updateProject()
                  }}
                  style={{ borderRadius: 20, width: 80 }}
                  type="primary"
                >
                  保 存
                </Button>
              </Col>
            </Row>

            <Row
              gutter={[8, 8]}
              justify="start"
              align="middle"
              style={{ marginBottom: 20 }}
            >
              <Col
                flex="80px"
                style={{ color: '#00000073', textAlign: 'left' }}
              >
                项目名称
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                <Input
                  placeholder="请输入项目名称"
                  required={true}
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value)
                  }}
                  style={{ borderRadius: 3, width: '100%' }}
                />
              </Col>
            </Row>

            <Row
              gutter={[8, 8]}
              justify="start"
              align="middle"
              style={{ marginBottom: 20 }}
            >
              <Col
                flex="80px"
                style={{ color: '#00000073', textAlign: 'left' }}
              >
                项目封面
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                <div className={myStyles.uploadCover}>
                  <Upload
                    beforeUpload={beforeCoverUpload}
                    accept={'image/*'}
                    action={
                      constants.BACKEND_API_URL +
                      'course/api/oam_upload_course_cover'
                    }
                    listType="picture-card"
                    name="image"
                    fileList={coverFileList}
                    onChange={onCoverChange}
                    data={uploadCoverData}
                    showUploadList={false}
                  >
                    {cover ? (
                      <img
                        id="video-cover"
                        style={{ width: '250px', height: '130px' }}
                        src={constants.BACKEND_API_URL + cover}
                      />
                    ) : (
                      uploadCoverButton
                    )}
                  </Upload>
                </div>
              </Col>
            </Row>


            <Row
              gutter={[8, 8]}
              justify="start"
              align="top"
              style={{ marginBottom: 20 }}
            >
              <Col
                flex="80px"
                style={{ color: '#00000073', textAlign: 'left' }}
              >
                实训目标
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                <TextArea
                  placeholder="请输入实训目标"
                  style={{ borderRadius: 3, width: '100%' }}
                  autoSize={{ minRows: 3 }}
                  value={projectAim}
                  onChange={(e) => {
                    setProjectAim(e.target.value)
                  }}
                />
              </Col>
            </Row>

            <Row
              gutter={[8, 8]}
              justify="start"
              align="top"
              style={{ marginBottom: 20 }}
            >
              <Col
                flex="80px"
                style={{ color: '#00000073', textAlign: 'left' }}
              >
                锻炼能力
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                <TextArea
                  placeholder="请输入锻炼能力，多个用英文分号‘;’隔开，例如 数据可视化;数据采集;分类模型"
                  style={{ borderRadius: 3, width: '100%' }}
                  autoSize={{ minRows: 3 }}
                  value={trainingSkills}
                  onChange={(e) => {
                    setTrainingSkills(e.target.value)
                  }}
                />
              </Col>
            </Row>

            <Row
              gutter={[8, 8]}
              justify="start"
              align="top"
              style={{ marginBottom: 20 }}
            >
              <Col
                flex="80px"
                style={{ color: '#00000073', textAlign: 'left' }}
              >
                实践工具
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                <TextArea
                  placeholder="请输入实践工具"
                  style={{ borderRadius: 3, width: '100%' }}
                  autoSize={{ minRows: 3 }}
                  value={tools}
                  onChange={(e) => {
                    setTools(e.target.value)
                  }}
                />
              </Col>
            </Row>




             <Row
              gutter={[8, 8]}
              justify="start"
              align="middle"
              style={{ marginBottom: 20 }}
            >
              <Col
                flex="80px"
                style={{ color: '#00000073', textAlign: 'left' }}
              >
                镜像
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                  <Radio.Group
                        value= {project?.env_id}
                        onChange={onProjectImageChange}
                        options={allImages?.map((item:any)=> { return {value:item?.id, label: item?.name}})}
                        //fieldNames={{value:'id', label:'name'}}
                    
                      />

                  
              </Col>
            </Row>


            <Row
              gutter={[8, 8]}
              justify="start"
              align="middle"
              style={{ marginBottom: 20 }}
            >
              <Col
                flex="80px"
                style={{ color: '#00000073', textAlign: 'left' }}
              >
                难度等级
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                  <Radio.Group
                        value= {project?.difficulty}
                        onChange={onProjectDifficultyChange}
                        options={[{label:'初级', value:1},{label:'中级', value:2},{label:'高级', value:3}]}        
                      />

                  
              </Col>
            </Row>



            <Row
              gutter={[8, 8]}
              justify="start"
              align="middle"
              style={{ marginBottom: 20 }}
            >
              <Col
                flex="80px"
                style={{ color: '#00000073', textAlign: 'left' }}
              >
                项目分类
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                  <Checkbox.Group
                        value= {project?.category_ids}
                        onChange={onProjectCategoryChange}
                        options={allCategory?.map((item:any)=> { return {value:item?.id, label: item?.name}})}                   
                      />
              </Col>
            </Row>



            <Row
              gutter={[8, 8]}
              justify="start"
              align="middle"
              style={{ marginBottom: 20 }}
            >
              <Col
                flex="80px"
                style={{ color: '#00000073', textAlign: 'left' }}
              >
                行业
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                <Input
                  placeholder="请输入行业"
                  required={true}
                  value={industry}
                  onChange={(e) => {
                    setIndustry(e.target.value)
                  }}
                  style={{ maxWidth: 200, borderRadius: 3, width: '100%' }}
                />
              </Col>
            </Row>

            <Row
              gutter={[8, 8]}
              justify="start"
              align="middle"
              style={{ marginBottom: 20 }}
            >
              <Col
                flex="80px"
                style={{ color: '#00000073', textAlign: 'left' }}
              >
                教学课时
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                <InputNumber
                  placeholder="请输入教学课时"
                  required={true}
                  value={teachingHours}
                  onChange={(newValue) => {
                    setTeachingHours(newValue)
                  }}
                  style={{ maxWidth: 200, borderRadius: 3, width: '100%' }}
                />
              </Col>
            </Row>

            <Row
              gutter={[8, 8]}
              justify="start"
              align="middle"
              style={{ marginBottom: 20 }}
            >
              <Col
                flex="80px"
                style={{ color: '#00000073', textAlign: 'left' }}
              >
                实训课时
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                <InputNumber
                  placeholder="请输入个人实训课时"
                  required={true}
                  value={learningHours}
                  onChange={(newValue) => {
                    setLearningHours(newValue)
                  }}
                  style={{ maxWidth: 200, borderRadius: 3, width: '100%' }}
                />
              </Col>
            </Row>

            <Row
              gutter={[8, 8]}
              justify="start"
              align="middle"
              style={{ marginBottom: 20 }}
            >
              <Col
                flex="80px"
                style={{ color: '#00000073', textAlign: 'left' }}
              >
                年付价格
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                <InputNumber
                  placeholder="请输入年付价格"
                  required={true}
                  precision={2}
                  min={0}
                  value={annualPriceYuan}
                  onChange={(newValue) => {
                    setAnnualPriceYuan(Number(newValue || 0))
                  }}
                  style={{ maxWidth: 200, borderRadius: 3, width: '100%' }}
                />
                <span style={{ marginLeft: 8, color: '#999' }}>元</span>
              </Col>
            </Row>

            <Row gutter={[8, 8]} justify="start" align="top" style={{ marginBottom: 20 }}>
              <Col flex="80px" style={{ color: '#00000073', textAlign: 'left' }}>
                前置基础
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                <TextArea
                  placeholder="请输入前置基础"
                  style={{ borderRadius: 3, width: '100%' }}
                  autoSize={{ minRows: 3 }}
                  value={precondition}
                  onChange={(e) => {
                    setPrecondition(e.target.value)
                  }}
                />
              </Col>
            </Row>

            <Row
              gutter={[8, 8]}
              justify="start"
              align="top"
              style={{ marginBottom: 20 }}
            >
              <Col
                flex="80px"
                style={{ color: '#00000073', textAlign: 'left' }}
              >
                项目介绍
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
              <div className={myStyles.markDownEditorWrapper}>
                  <MarkDownEditor
                    preview={false}
                    height={400}
                    placeholder="请输入项目介绍"
                    onChange={onDescMarkdownChange}
                    value={introduction}
                    uploadOption={uploadOption}
                    toolbar={'all'}
                />
              </div>
              </Col>
            </Row>
            {/*
              <Row
                gutter={[8, 8]}
                justify="start"
                align="middle"
                style={{ marginBottom: 20 }}
              >
                <Col
                  flex="80px"
                  style={{ color: '#00000073', textAlign: 'left' }}
                >
                  项目流程
                </Col>
                <Col
                  className={GlobalCss.ColFlex}
                  flex="auto"
                  style={{ textAlign: 'left', gap: '10px' }}
                >
                  <Button
                    onClick={addStepBtnClick}
                    style={{ padding: '0px 2px' }}
                    type="primary"
                  >
                    + 流程
                  </Button>
                  {
                    <Popover
                      arrowPointAtCenter={true}
                      trigger="click"
                      placement="top"
                      content={<ProjectSteps />}
                      title="项目流程"
                    >
                      <Button className={GlobalCss.defBtn}>预览</Button>
                    </Popover>
                  }
                </Col>
              </Row>
              <div style={{ marginLeft: '80px', marginBottom: '20px' }}>
                {projectSteps?.map((step, i) => (
                  <div key={i}>
                    <Row
                      align={'middle'}
                      justify={'start'}
                      style={{ gap: '10px', marginBottom: '10px' }}
                    >
                      <Col style={{ color: '#325D63' }}>{'流程 ' + (i + 1)}</Col>
                      <Col flex={'auto'}>
                        <Input
                          value={step.step}
                          onChange={(e) => {
                            projectSteps[i].step = e.target.value
                            setProjectSteps([...projectSteps])
                          }}
                        />
                      </Col>
                      <Col flex={'140px'} className={GlobalCss.ColFlex} style={{ gap: '10px' }}>
                        <Button
                          onClick={() => {
                            step.subSteps?.push('')
                            setProjectSteps([...projectSteps])
                          }}
                          type="primary"
                        >
                          添加
                        </Button>
                        <Popconfirm
                          placement="top"
                          title={'确认删除流程' + (i + 1) + '吗？'}
                          onConfirm={() => {
                            projectSteps.splice(i, 1)
                            setProjectSteps([...projectSteps])
                          }}
                          okText="确认"
                          cancelText="取消"
                        >
                          <Button className={GlobalCss.defBtn}>删除</Button>
                        </Popconfirm>
                      </Col>
                    </Row>
                    {step.subSteps?.map((childStep, j) => (
                      <Row
                        key={i + '-' + j}
                        align={'middle'}
                        style={{
                          marginLeft: '48px',
                          marginBottom: '10px',
                          gap: '10px',
                        }}
                      >
                      <Col flex={'30px'}>
                          <div>
                            {(i + 1) + '.' + (j + 1)}
                          </div>

    
                        </Col>

                        <Col flex={'auto'}>
                          <Input
                            value={childStep}
                            onChange={(e) => {
                              projectSteps[i].subSteps[j] = e.target.value
                              setProjectSteps([...projectSteps])
                            }}
                          />
                        </Col>
                        <Col flex={'140px'}>
                          <Popconfirm
                            placement="top"
                            title={'确认删除吗？'}
                            onConfirm={() => {
                              projectSteps[i].subSteps.splice(j, 1)
                              setProjectSteps([...projectSteps])
                            }}
                            okText="确认"
                            cancelText="取消"
                          >
                          <Button className={GlobalCss.defBtn}>删除</Button>
                          </Popconfirm>
                        </Col>
                      </Row>
                    ))}
                  </div>
                ))}
              </div>
            */}

            <Row
              gutter={[8, 8]}
              justify="start"
              align="middle"
              style={{ marginBottom: 20 }}
            >
              <Col
                flex="80px"
                style={{ color: '#00000073', textAlign: 'left' }}
              >
                项目大纲
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                <span style={{verticalAlign:'bottom' , color:'#3d6b74', background:'#E6ECED', borderRadius:3, display:'inline-block', height:32, width:250}}>
                  <span title={String(projectMenu) + ' ' + projectMenuName}  style={{ padding:'5px 10px', overflow:'hidden', whiteSpace: 'nowrap', display:'inline-block', textOverflow:"ellipsis", width:250}}> 
                    {projectMenu} {' '} {projectMenuName} 
                  </span>
                </span>

                <Button style={{marginLeft: 10}} onClick={() => {window.open('/oam_menu_edit?menu_id=' + projectMenu)}} className={GlobalCss.defBtn}>
                <EditOutlined /> 编辑</Button> 

              </Col>
            </Row>

            <Row
              gutter={[8, 8]}
              justify="start"
              align="middle"
              style={{ marginBottom: 20 }}
            >
              <Col
                flex="80px"
                style={{ color: '#00000073', textAlign: 'left' }}
              >
                报告模板
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>

              <span style={{verticalAlign:'bottom' , color:'#3d6b74', background:'#E6ECED', borderRadius:3, display:'inline-block', height:32, width:250}}>
                <span title={String(projectReportId) + ' ' + projectReportName}  style={{ padding:'5px 10px', overflow:'hidden', whiteSpace: 'nowrap', display:'inline-block', textOverflow:"ellipsis", width:250}}> 
                  {projectReportId} {' '} {projectReportName} 
                </span>
              </span>

              <Button style={{marginLeft: 10}} onClick={() => {window.open('/oam_report_edit?report_id=' + projectReportId)}} className={GlobalCss.defBtn}>
                <EditOutlined /> 编辑
              </Button> 

              <Button style={{marginLeft: 10}}  onClick={fullReportRunning == true? ()=>{}: () => { generateFullReport()}} className={GlobalCss.defBtn}>
                {fullReportRunning  && <span> <Spin size="small" /> 生成中</span>}
                { !fullReportRunning && existFullReport && <span> 重新生成 </span>}
                { !fullReportRunning && !existFullReport && <span> 生成报告 </span>}
              </Button> 

              {fullReportRunning && <Button style={{marginLeft: 10, color:'#D90000', borderColor:'#D90000' }} onClick={() => {setStopFullReportTaskModalVis(true)}} className={GlobalCss.defBtn}>
                停止生成
              </Button> }

              { !fullReportRunning && errorDataList && <Button style={{marginLeft: 10, color:'#D90000', borderColor:'#D90000' }} onClick={() => {setIsErrorMeaasgeModalVisible(true)}} className={GlobalCss.defBtn}>
                错误信息
              </Button> }

              { existFullReport && !fullReportRunning &&  !errorDataList && <Button style={{marginLeft: 10}} onClick={() => {window.open('/full_report_preview?project_id=' + project_id + '&')  }} className={GlobalCss.defBtn}>
                预览报告
              </Button> }

              <Tooltip title="此处生成的报告为参考报告"><ExclamationCircleOutlined style={{color:'#999', marginLeft:5}}/></Tooltip>

              </Col>
            </Row>

            <Row
              gutter={[8, 8]}
              justify="start"
              align="middle"
              style={{ marginBottom: 20 }}
            >
              <Col
                flex="80px"
                style={{ color: '#00000073', textAlign: 'left' }}
              >
                检测习题
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>

                <DragDropContext onDragEnd={onDragEnd}>
                  <Droppable droppableId="droppable" direction="horizontal">
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        style={getListStyle(snapshot.isDraggingOver)}
                        {...provided.droppableProps}
                      >
                        {exercistList?.map((item, index) => (
                          <DndDraggable
                            key={item}
                            draggableId={String(item)}
                            index={index}
                          >
                            {(provided, snapshot) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                className={myStyles.myExerciseDiv}
                                style={getItemStyle(
                                  snapshot.isDragging,
                                  provided.draggableProps.style
                                )}
                              >
                                <div className={myStyles.myExerciseAcitionDiv}>
                                  <Popconfirm
                                    placement="bottom"
                                    title={'您确定删除此习题吗？'}
                                    onCancel={(e: any) => {
                                      e.stopPropagation()
                                    }}
                                    onConfirm={() => {
                                      setExerciseList(
                                        exercistList.filter(
                                          (exercise) => exercise !== item
                                        )
                                      )
                                    }}
                                    okText="确认"
                                    cancelText="取消"
                                  >
                                    <CloseCircleOutlined
                                      onClick={(e: any) => {
                                        e.stopPropagation()
                                      }}
                                      style={{
                                        borderRadius: 6,
                                        backgroundColor: '#fff',
                                        fontSize: 12,
                                        color: '#FF4D4F',
                                        zIndex: 10000,
                                      }}
                                    />
                                  </Popconfirm>
                                </div>

                                <div style={{ padding: grid }}>{item}</div>
                              </div>
                            )}
                          </DndDraggable>
                        ))}
                        {provided.placeholder}
                        <Button
                          onClick={() => {
                            showAddExerciseModal()
                          }}
                          style={{
                            color: '#4f46e5',
                            border: '1px dashed #4f46e5',
                            //width: 38,
                            height: 38,
                            marginRight: 8,
                          }}
                          type="default"
                        >
                          +
                        </Button>
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </Col>
            </Row>
          </div>

          <ConfigProvider locale={zhCN}>
            <Modal title={
                <div style={{ width: '100%', cursor: 'move',}}
                  onMouseOver={() => { if (disabled) {setDisabled(false)}}}
                  onMouseOut={() => {setDisabled(true)}}
                  onFocus={() => {}}
                  onBlur={() => {}}
                >
                  添加检测习题
                </div>
              }
              closable={false}
              open={isAddExerciseModalVisible}
              onOk={handleAddExerciseOk}
              onCancel={handleAddExerciseCancel}
              bodyStyle={{ height: 550, overflow: 'hidden' }}
              destroyOnClose={true}
              width={600}
              modalRender={(modal) => (
                <div className={myStyles.createDiv}>
                  <Draggable
                    disabled={disabled}
                    bounds={bounds}
                    onStart={(event, uiData) => onStart(event, uiData)}
                  >
                    <div ref={draggleRef}>{modal}</div>
                  </Draggable>{' '}
                </div>
              )}
            >
              <Input
                onPressEnter={onSearchTaskBtn}
                placeholder="搜索习题"
                style={{
                  float: 'left',
                  borderRadius: 20,
                  width: 300,
                  marginBottom: 10,
                }}
                suffix={<SearchOutlined style={{ color: '#666666' }} />}
              />
              <div className={idataCodingTableStyles.tableWrapper}>
                <ConfigProvider locale={zhCN}>
                  <Table
                    dataSource={exerciseListResult}
                    columns={exercise_columns}
                    rowKey={(record) => record.id}
                    pagination={false}
                    size="small"
                    //scroll={{ x: 600 }}
                    //bordered={true}
                    onChange={onExerciseTableChange}
                    rowSelection={{
                      type: 'radio',
                      ...rowTaskSelection,
                    }}
                  />
                </ConfigProvider>
              </div>

              <ConfigProvider locale={zhCN}>
                <div
                  style={{
                    marginBottom: 30,
                    paddingTop: 30,
                    textAlign: 'center',
                  }}
                  className={'css.pagination'}
                >
                  <Pagination
                    defaultCurrent={1}
                    total={exerciseResultSum}
                    defaultPageSize={10}
                    hideOnSinglePage={true}
                    current={exercisePage.current}
                    onChange={onExercisePageChange}
                    showTotal={(total) => `找到 ${total} 习题`}
                    showSizeChanger={false}
                  />
                </div>
              </ConfigProvider>
            </Modal> 
          </ConfigProvider>
        </Content>


        <PublicTipModal
          modalContent={
          <div style={{textAlign:'center'}}>
              确定要停止生成报告吗？
          </div>
          }
          modalTitle={'提示'}
          handleOk={()=>{setStopFullReportTaskModalVis(false); stopFullReportTask()}}
          handleCancel={()=>{setStopFullReportTaskModalVis(false)}}
          open={stopFullReportTaskModalVis}
          setOpen={setStopFullReportTaskModalVis}
        />

      </div>

      <ConfigProvider locale={zhCN}>
            <Modal title={
                <div style={{ width: '100%', cursor: 'move',}}
                  onMouseOver={() => { if (disabled) {setErrorDisabled(false)}}}
                  onMouseOut={() => {setErrorDisabled(true)}}
                  onFocus={() => {}}
                  onBlur={() => {}}
                >
                  错误信息
                </div>
              }
              closable={true}
              open={isErrorMeaasgeModalVisible}
              onOk={handleAddExerciseOk}
              onCancel={()=>{setIsErrorMeaasgeModalVisible(false)}}
              footer={null}
              bodyStyle={{ height: 550, overflow: 'hidden' }}
              destroyOnClose={true}
              width={800}
              modalRender={(modal) => (
                <div className={myStyles.createDiv}>
                  <Draggable
                    disabled={errorDisabled}
                    bounds={errorBounds}
                    onStart={(event, uiData) => onErrorStart(event, uiData)}
                  >
                    <div ref={draggleErrorMessageRef}>{modal}</div>
                  </Draggable>{' '}
                </div>
              )}
            >
              <div className={idataCodingTableStyles.tableWrapper}>
                <ConfigProvider locale={zhCN}>
                  <Table
                    dataSource={errorDataList}
                    columns={error_columns}
                    rowKey={(record) => record.node_id}
                    pagination={{ pageSize: 10,position:['bottomCenter'] ,hideOnSinglePage:true}}
                    //size="small"
                  />
                </ConfigProvider>
              </div>
            </Modal> 
          </ConfigProvider>

    </Layout>
  )
}

export default OAMProjectEdit
